
import { useState } from "react";

import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    Approves,
    BigToString
// } from '../../ethers/e'
} from '../../ethers/e'

import {
    Multi,
    SilverPool,
    Usdt
} from '../../chain/silver'

import {useEthers} from '../../ethers'
import useButtonText from '../useButtonText'
import useInput from '../useInput';
import useToast from '../useToast'

// import {useSilver} from '../../context/silver'
import { useTranslation } from 'react-i18next';

function Error(e) {
    return e.data ? e.data.data ? e.data.data.message : (e.data.message ? e.data.message : e.message) : e.message
}

export function useHarvest() {
    const {account} = useEthers()
    const {open} = useToast()
    const {t} = useTranslation()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(t('Harvest'))

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.unlockGold(account)
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open(t("Success"))
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return button
}

export function useGoldVIP() {
    const {open} = useToast()
    const {t} = useTranslation()

    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(t('Upgrade to VIP'))

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.buyGold()
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open(t("Success"))
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return button
}

export function useBuyGoldPostion() {
    // buyGoldPostion
    const inviter = useInput("")
    const inputAmount = useInput("", {type: "number", placeholder: "0.0"})
    const {open} = useToast()
    const {t} = useTranslation()

    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(t('Purchase'))

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const silverPool = SilverPool()
        const _amountWei = EtherToWei(inputAmount.value)


        const usdt = Usdt()
        // 这里可以封装成组建
        let {
            tx,
            error
        } = await Approves(
            [
                {
                    token: usdt.token,
                    amountWei: _amountWei,
                    sender: silverPool.address,
                    isMax: true,
                    needClear: true
                }
            ],
            {
                provider: GetGlobalSigner(),
                callback({
                    // status,
                    // token,
                    error
                }) {
                    // console.log("callback ", result)
                    // setButtonText("Approve")
                    if ( error ) {
                        open(t('Approve')+" "+t('Cancel'), "error")
                    } else {
                        open(t('Approve')+" "+t('Success'))
                    }
                    
            }
            }
        )

        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            if ( !error ) {
                await tx.wait()
            }
        // let _inviter = inviter.value === '' ?  : inviter.value
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            tx = await silverPool.buyGoldPostion(_amountWei)
            await tx.wait()
            open(t("Success"))

            inviter.onChange(-1)
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        inputAmount,
        inviter,
        button
    }
}